<!--
 * @Description 渠道红包
 * @Author v_huwenjuan
 * @Date 2023-2-20
-->
<template>
    <div class="page-wapper">
        <mui-loading
            v-if="showLoading"
            :visable="showLoading"
            theme="blue"
        />
        <mui-errorloading v-else-if="isError"/>
        <div
            v-else
            class="main"
            :style="{backgroundImage: 'url(' + (pageData.bg_img || bg_img) + ')',
                     backgroundColor: (pageData.bg_color || bg_color),
                     paddingTop: pageData.top_dis + 'vw'}"
        >
            <div
                v-if="showShare"
                class="head-rule"
                @click="handleShare"
            >分享</div>
            <div class="content-wrapper">
                <!-- 第一次进入输手机号领取状态 -->
                <section v-if="!couponInfo.length && !noNetwork" class="box1">
                    <div class="phone-title">
                        {{ pageData.page_title }}
                    </div>
                    <div class="input-box" @click="focus">
                        <input
                            ref="input"
                            v-model="phone"
                            type="tel"
                            class="cell-number"
                            maxlength="11"
                            placeholder="输入手机号，领打车红包"
                            @blur="formatMobile"
                        >
                        <div
                            v-if="phone"
                            class="close"
                            @click="inputClick"
                        ></div>
                    </div>
                    <div
                        class="btn-get"
                        :class="{'disable': isActive}"
                        @click="getCouponData"
                    >{{ pageData.btn_name }}</div>
                </section>
                <!-- 领券状态 -->
                <section v-if="couponInfo.length && !noNetwork" class="box2">
                    <div class="phone-title">
                        {{ pageData.page_title }}
                    </div>
                    <div class="content">
                        <div
                            v-for="(item, index) in couponInfo"
                            :key="index"
                            class="coupon"
                        >
                            <div class="price">
                                {{ item.discount_num }}
                                <span class="unit">{{ item.discount_unit }}</span>
                            </div>
                            <div class="desc">
                                <span class="coupon-name">{{ item.name }}</span>
                                <span class="new-or-old">{{ item.discount_desc }}</span>
                                <span class="expire no-newuser-logo">{{ item.limit_desc }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="car-btn" @click="jumpUrl">
                        <div class="btn">{{ pageData.btn_name }}</div>
                    </div>
                </section>
                <!-- 前端请求无法发送 -->
                <section
                    v-if="noNetwork"
                    class="box1"
                    style="height:87.5vw"
                >
                    <div class="phone-title">
                        {{ pageData.page_title }}
                    </div>
                    <div class="error"></div>
                    <div class="error-text">{{ btnTip }}</div>
                    <div class="car-btn" @click="jumpUrl">
                        <div class="btn">{{ pageData.btn_name }}</div>
                    </div>
                </section>
                <!-- 活动规则部分 -->
                <section class="box3">
                    <div class="phone-title">
                        活动规则
                    </div>
                    <!--bca-disable-next-line-->
                    <div id="rules-frame" v-html="tip"></div>
                </section>
            </div>
        </div>
    </div>

</template>

<script>

import './Main.scss';
import {jumpDacheMain, jumpDachePage} from '../../constant/JumpFunc.js';
import server from '../../service.js';
import com from '@/common/utils/com.js';
import {homeShare} from '../../constant/ShareConfig.js';
import StatisticConst from '../../constant/StatisticConst.js';

export default {
    data() {
        return {
            pageData: {},
            bg_img: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/taxi/default/dingbutu%402X.png',
            bg_color: '#c8ffff',
            serverParams: '', // 服务端透传字段
            isShowShare: false, // 是否展示分享按钮
            pageTitle: '', // 页面标题
            isError: false,
            imgReady: true, // 图片预加载完毕标志位
            isActive: false, // 按钮可点击状态
            tip: '',
            phone: '',
            couponInfo: [],
            group: [],
            fr: '', // 来源参数
            jumpUrlBtn: '',
            noNetwork: false,
            btnTip: '活动暂时无法领取',
            phoneLoc: ''
        };
    },
    computed: {
        /**
         * 端内隐藏分享
         */
        showShare() {
            return com.plat.isNative;
            // return true;
        },
        /**
         * 显示loading
         */
        showLoading() {
            return this.imgReady;
        },
        isNative() {
            return com.plat.isNative;
            // return true;
        }
    },
    watch: {
        phone(val) {
            if (val.length >= 11) {
                this.isActive = true;
            }
            else {
                this.isActive = false;
            }
        }
    },
    async created() {
        // 获取 url 参数
        this.urlParams = com.getParamsFromUrl();
        // 先拉取活动状态
        await this.getPageData();
    },
    mounted() {
        this.fr = this.urlParams.fr || 'default';
        // 首页展示统计
        StatisticConst.homeFrom({
            fr: this.fr,
            activity_type: this.urlParams.no
        });
        homeShare(this.urlParams.no);

        // 取出缓存中的手机号并对比时间是否过期
        if (localStorage.length !== 0) {
            let nowDate = new Date();
            let localDate = new Date(localStorage.getItem('time'));
            // 计算缓存时间和当前时间差
            let dateDiff = nowDate.getTime() - localDate.getTime();
            let hour = dateDiff / (3600 * 1000);
            if (hour < 24) {
                // 缓存不过期读取缓存手机号进入领取逻辑
                this.phoneLoc = localStorage.getItem('userPhone');
                this.formatMobile();
            }
            else {
                localStorage.clear();
            }
        }
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        /**
         * 格式化手机号
         */
        formatMobile() {
            if (this.phone.length === 11) {
                this.phone = this.phone.replace(/\s*/g, '');
                let result = [];
                for (let i = 0; i < this.phone.length; i++) {
                    if (i === 3 || i === 7) {
                        result.push(' ' + this.phone.charAt(i));
                    }
                    else {
                        result.push(this.phone.charAt(i));
                    }
                }
                this.phone = result.join('');
            }
        },

        /**
         * 页面信息接口
         */
        async getPageData() {
            const param = {
                no: this.urlParams.no,
                fr: this.urlParams.fr,
                prev: this.urlParams.prev
            };
            await server('getPageData', param)
                .then(res => {
                    if (res.err_no === 0) {
                        this.imgReady = false;
                        // 获取页面样式配置
                        this.pageData = res.data;
                        // 服务透传字段
                        this.serverParams = res.data.server_params;
                        // 手机号
                        this.phone = this.pageData.user_mobile || this.phoneLoc;
                        // 是否展示分享按钮
                        this.isShowShare = res.data.is_show_share;
                        // 页面标题
                        this.pageTitle = res.data.page_title;
                        document.title = this.pageTitle;
                        this.tip = this.pageData.rule_desc;
                    }
                    else {
                        this.$toast('获取数据失败');
                        this.imgReady = false;
                    }
                })
                .catch(e => {
                    this.$toast('网络连接失败');
                    this.imgReady = false;
                });
        },

        /**
         * 根据手机号调用接口领取红包
         */
        getCouponData() {
            // 领取红包统计
            StatisticConst.getCoupon({
                fr: this.fr,
                activity_type: this.urlParams.no
            });
            if (!this.isActive) {
                return;
            }
            // 校验手机号
            if (!(/^1[3,4,5,6,7,8,9](\d|\*){9}$/.test(this.phone.replace(/\s/g, '')))) {
                this.$toast('请输入正确的手机号');
                this.phone = '';
                return;
            }
            // 第一次提交 缓存时间和手机号
            if (localStorage.getItem('userPhone') === null) {
                let localDate = new Date();
                localStorage.setItem('userPhone', this.phone.replace(/\s/g, ''));
                localStorage.setItem('time', localDate);
            }
            const param = {
                server_params: encodeURIComponent(this.serverParams),
                user_mobile: this.phone.replace(/\s/g, '')
            };
            server('getCouponData', param)
                .then(res => {
                    let couData = res.data;
                    if (res.err_no === 0) {
                        if (couData.btn_status === 0) {
                            // 领券成功
                            couData.toast_tip && this.$toast(couData.toast_tip);
                            this.pageData.btn_name = couData.btn_name;
                            this.jumpUrlBtn = couData.btn_link;
                            this.couponInfo = couData.discount_list;
                        }
                        else {
                            // 领券失败，弹toast提示
                            couData.btn_tip && (this.btnTip = couData.btn_tip);
                            this.pageData.btn_name = couData.btn_name;
                            this.jumpUrlBtn = couData.btn_link;
                            this.noNetwork = true;
                        }
                    }
                    else {
                        this.noNetwork = true;
                    }
                }
                )
                .catch(e => {
                    this.$toast('领取失败,请稍后重试');
                });
        },

        /**
         * 输入框事件
         */
        inputClick() {
            // 增加统计，清除输入框
            StatisticConst.input();
            this.phone = '';
        },

        /**
         * 点击跳转
         */
        jumpUrl() {
            // 端外直接跳端
            if (!this.isNative) {
                jumpDachePage();
                return;
            }
            window.location = this.jumpUrlBtn;
        },

        handleShare() {
            // 添加分享统计
            // StatisticConst.shareBtnClick();
            window.yymap.naa.openShare();
        },

        /**
         * 跳转至打车页面
         */
        jumpDache() {
            // 打车按钮统计
            StatisticConst.goDache();
            jumpDacheMain();
        }
    }
};
</script>

<style lang="scss" scoped></style>
